// Lib
import { isEmpty } from 'lodash';
import { CopyPaste } from 'handsontable/plugins';

// Utils
import { parseTableHTMLFromClipboardData } from '../utils/tableDataUtils';

/**
 * NOTE: This plugin is shared between the legacy and new table implementations.
 *   If it needs to be modified for a particular version, please ensure that a copy
 *   is made and can operate independently.
 */
class MilanoteCopyPastePlugin extends CopyPaste {
    /**
     * This is copied from Handsontable's CopyPaste.ts.
     *
     * Changes:
     * - Instead of Handsontable's method of parsing HTML table string, using a function
     *   consistent to how Milanote parse HTML table strings in other parts of the codebase.
     */
    onPaste(event: ClipboardEvent): void {
        // @ts-ignore - Handsontable private property
        if (!this.hot.isListening() || this.isEditorOpened()) return;

        if (event && event.preventDefault) {
            event.preventDefault();
        }

        const { values } = (event.clipboardData && parseTableHTMLFromClipboardData(event.clipboardData)) || {};

        if (values === undefined || isEmpty(values)) return;

        // @ts-ignore - Handsontable private property
        if (this.hot.runHooks('beforePaste', values, this.copyableRanges) === false) return;

        // @ts-ignore - Handsontable private property
        const [startRow, startColumn, endRow, endColumn] = this.populateValues(values);

        this.hot.selectCell(
            startRow,
            startColumn,
            Math.min(this.hot.countRows() - 1, endRow),
            Math.min(this.hot.countCols() - 1, endColumn),
        );

        // @ts-ignore - Handsontable private property
        this.hot.runHooks('afterPaste', values, this.copyableRanges);
    }
}

export default MilanoteCopyPastePlugin;
